import dayjs from 'dayjs';
import type { BelongsToPopulatedValue, PopulatedEntry } from '../types';

export function parseComparableDatePart(value: unknown): string | null {
	if (value == null || value === '') {
		return null;
	}
	const s = String(value).trim();
	const leading = /^(\d{4}-\d{2}-\d{2})/.exec(s)?.[1];
	if (leading) {
		return leading;
	}
	const parsed = dayjs(s);
	return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
}

export function matchesResolvedDataFilter(
	row: { data: Record<string, unknown> },
	filterJson: string | undefined,
): boolean {
	if (!filterJson?.trim()) {
		return true;
	}
	let doc: unknown;
	try {
		doc = JSON.parse(filterJson);
	} catch {
		return true;
	}
	if (doc === null || typeof doc !== 'object' || Array.isArray(doc)) {
		return true;
	}
	for (const [slug, raw] of Object.entries(doc as Record<string, unknown>)) {
		if (!slug || raw === null || typeof raw !== 'object' || Array.isArray(raw)) {
			continue;
		}
		const spec = raw as Record<string, unknown>;
		const targetEntryId = typeof spec.targetEntryId === 'string' ? spec.targetEntryId.trim() : '';
		if (targetEntryId) {
			const value = row.data[slug];
			const links = Array.isArray(value) ? value as BelongsToPopulatedValue[] : [];
			const hasTarget = links.some((link) => String(link?.value ?? '').trim() === targetEntryId);
			if (!hasTarget) {
				return false;
			}
			continue;
		}
		if (spec.isUnset === true) {
			if (parseComparableDatePart(row.data[slug]) !== null) {
				return false;
			}
			continue;
		}
		const rowDate = parseComparableDatePart(row.data[slug]);
		if (!rowDate) {
			return false;
		}
		const start = parseComparableDatePart(spec.start);
		if (start && rowDate < start) {
			return false;
		}
		const end = parseComparableDatePart(spec.end);
		if (end && rowDate > end) {
			return false;
		}
	}
	return true;
}

export function filterOfflineRowsByArchivedAndDataFilter(
	rows: PopulatedEntry[],
	includeArchived: boolean,
	resolvedFilterJson: string | undefined,
): PopulatedEntry[] {
	return rows
		.filter((row) => includeArchived || row.isArchived !== true)
		.filter((row) => matchesResolvedDataFilter(row, resolvedFilterJson));
}
